import axios from 'axios'

export default {
  namespaced: true,
  state: {
    users: [],
    loading: false
  },
  mutations: {
    loading(state, value) {
      state.loading = value
    },
    users(state, value) {
      state.users = value
    },
    ADD(state, item) {
      state.users.unshift(item)
    },
    UPDATE(state, user) {
      const index = state.users.findIndex((p) => p.id === user.id)
      if (index >= 0) Object.assign(state.users[index], user)
    },
    REMOVE(state, itemId) {
      let ItemIndex = state.users.findIndex((p) => p.id === itemId)
      state.users.splice(ItemIndex, 1)
    },
  },
  actions: {
    getUsers({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('loading', true)
        axios.get('/user')
          .then((response) => {
            commit('users', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            commit('loading', false)
          })
      })
    },
    getUser({commit, state}, id) {
      return axios.get('/user/' + id)
        .then(({data}) => {
          return Promise.resolve(data)
        })
    },
    updateItem({commit, state}, item) {
      return new Promise((resolve, reject) => {
        commit('loading', true)
        axios.post('/profile', {
          name: item.name,
          surname: item.surname,
          date: item.date,
          notification: item.notification,
          sex: item.sex,
          password: item.password,
          email: item.email,
          phone: item.phone,
          city: item.city,
          avatar: item.avatar,
          description: item.description,
          _method: 'PATCH'
        })
          .then((response) => {
            console.log(response)
            commit('UPDATE', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            commit('loading', false)
          })
      })
    },
    addItem({commit, state}, item) {
      return new Promise((resolve, reject) => {
        commit('loading', true)
        axios.post('/user/', item)
          .then((response) => {
            commit('ADD', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            commit('loading', false)
          })
      })
    },
    removeItem({commit}, {itemId}) {
      return new Promise((resolve, reject) => {
        axios.delete(`/user/${itemId}`)
          .then((response) => {
            commit('REMOVE', itemId)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            commit('loading', false)
          })
      })
    },
  },
  getters: {
    users: state => state.users,
    loading: state => state.loading
  }
}
